export const fallbackNewsItems = [
  {
    id: "dummy-policy-briefing",
    date: "June 2026",
    title: "Policy briefing on Syria and regional security",
    author: "Rasha Corti",
    excerpt:
      "Rasha Corti will contribute expert analysis on current political and security developments in Syria and the wider region.",
    imageUrl: "",
  },
  {
    id: "dummy-keynote",
    date: "May 2026",
    title: "Keynote on migration and integration",
    author: "Rasha Corti",
    excerpt:
      "A public keynote focused on integration policy, social cohesion, and cross-cultural dialogue in Europe.",
    imageUrl: "",
  },
  {
    id: "dummy-research-note",
    date: "April 2026",
    title: "New research note in preparation",
    author: "Rasha Corti",
    excerpt:
      "A forthcoming note will examine socio-economic conditions, reconstruction priorities, and stakeholder engagement in Syria.",
    imageUrl: "",
  },
];

export function formatNewsDate(dateValue) {
  if (!dateValue) {
    return "";
  }

  if (typeof dateValue === "string") {
    return dateValue;
  }

  const date =
    typeof dateValue.toDate === "function" ? dateValue.toDate() : dateValue;

  return new Intl.DateTimeFormat("en", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}
